export function getItemSession(item: string, field: string): string {
  const storageItem = localStorage.getItem(item);
  if (storageItem) {
    const sessionObject = JSON.parse(storageItem);
    return sessionObject[field];
  }
  return null;
}
